import { RouteComponentProps } from 'react-router-dom'
import { DefaultGenerics, EnrichedActivity, EnrichedUser } from 'getstream'

import { get } from '@/services/awsAmplify'

import { ContestStatus } from '@/enums'
import { IContest, IConversation, IExplorerContest, IUser } from '@/interfaces'

export type IContestDiscoveryFeedContestData = {
  category: string
  name: string
  creatorName: string
  creatorAvatar: string
  creatorVideo: string
  maxParticipants: number
  prizePool: number
  startDate: number
  videoLengthLimit: number
  status: ContestStatus
  seasonNumber: number
  configurationId: UUID
  createdAt: number
  creatorVideoPreview: string
  creatorVideoThumbnail: string
  creatorVideoThumbnailSmall: string
  endDate: number
  id: UUID
  minParticipants: number
  participantsCount: number
  submissionDate: number
  updatedAt: number
  userId: UUID
  votingDate: number
  description?: string
} & DefaultGenerics

export type IContestDiscoveryFeedUserDataType = {
  name: string
  displayName?: string
  profileImage: UrlString
} & DefaultGenerics

export type IContestDiscoveryFeedActivityExtendType = {
  contestId: string
  video: UrlString
  videoThumbnail: UrlString
  videoPreview: string
} & DefaultGenerics

export type IContestDiscoveryFeedActivityType = Modify<
  EnrichedActivity<
    | IContestDiscoveryFeedUserDataType
    | IContestDiscoveryFeedActivityExtendType
    | IContestDiscoveryFeedContestData
  >,
  {
    actor: IUser
    object?: {
      data: {
        name: string
        participantsCount: number
        hideVotesCount: boolean
        imageAspectRatio: number
      } & IConversation &
        IContest
    }
    history: RouteComponentProps['history']
    imageAspectRatio: number
    index: number
    isActiveActivity: boolean
    time: string
    id: UUID
    contestId: UUID
    foreign_id: string
    votesCount: number
    videoPreview: string
    videoThumbnail: string
    verb: string
    origin: string
    reaction_counts: { COMMENT: number }
    inViewport: (activityId: UUID) => void
    outViewport: (activityId: UUID) => void
  }
>

export type IContestDiscoveryFeedUserType =
  EnrichedUser<IContestDiscoveryFeedUserDataType>

export const getExplorerContest = async (
  contestId: UUID,
  params: {
    limit?: number
    id_lt?: string
  }
) => {
  const data = await get({
    path: `/explorer/contests/${contestId}`,
    params,
    endpoint: 'cached',
  })

  return data
}

export const getExplorerFeed = async (params: {
  limit?: number
  id_lt?: string
  q?: string
}): Promise<{ results: IExplorerContest[]; lastKey?: string }> => {
  try {
    const data = await get({
      path: '/explorer',
      params,
      endpoint: 'cached',
    })

    return {
      results: (data?.results || []) as IExplorerContest[],
      lastKey: (data?.lastKey as string) || undefined,
    }
  } catch (e) {
    throw Error(e)
  }
}
